module.exports = __webpack_public_path__ + "static/media/logoFooter-white.bb79e93e.svg";